import {TypedShapeCommand} from '../commands.template';
import {IResourceJson} from '../../diagram-data/diagram-json-handler.service';
import {isComponent} from '../../diagram-render/helpers/shapes-detectors.util';
import {v4 as uuidv4} from 'uuid';

export class ResourceHideCommand extends TypedShapeCommand<IResourceJson> {
  protected services: any;
  private hidden: boolean;
  private skipRecalculation: boolean;

  id = uuidv4();

  constructor(data) {
    super(data);
    this.hidden = Boolean(this.object.hidden);
  }

  public execute() {
    super.execute();
    const model = this.services.registry.getGraph().getModel();
    const cell = model.getCell(this.object.activityMxKey);
    const cellJson = cell.getJson();
    const resource = cellJson.resources.find(
      res => Number(res.mxKey) === Number(this.object.mxKey)
    );

    this.skipRecalculation = resource?.main;
    model.beginUpdate();
    cell.skipUndo = true;

    if (!this.skipRecalculation) {
      this.services.resourceSvc.recalcActivitySize(cell, cell.getJson(), {
        remove: this.hidden,
        deltaKey: !this.hidden ? this.id : null
      });
    }

    this.services.diagramUpdateSvc.update({
      changeResource: {
        activityMxKey: this.object.activityMxKey,
        mxKey: this.object.mxKey,
        hidden: this.hidden
      }
    });
    model.endUpdate();

    if (isComponent(cell)) {
      cell.comp.instance.setupFromJson();
    }
  }

  public reverse() {
    super.reverse();
    const model = this.services.registry.getGraph().getModel();
    const cell = model.getCell(this.object.activityMxKey);

    model.beginUpdate();
    cell.skipUndo = true;

    if (!this.skipRecalculation) {
      this.services.resourceSvc.recalcActivitySize(cell, cell.getJson(), {
        remove: !this.hidden,
        deltaKey: !this.hidden ? this.id : null
      });
    }

    this.services.diagramUpdateSvc.update({
      changeResource: {
        activityMxKey: this.object.activityMxKey,
        mxKey: this.object.mxKey,
        hidden: !this.hidden
      }
    });
    model.endUpdate();

    if (isComponent(cell)) {
      cell.comp.instance.setupFromJson();
    }
  }
}
